export const filter = {
    init: function () {
        // set municipality by select
        $(document).on('change','.filters input', function(e) {
            e.preventDefault();
            $(this).closest('form').submit();
        });
    },
};
